import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  LongTextInput,
  EditButton,
  DateField,
  NumberField,
  NumberInput,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
} from 'react-admin';

const required = (message = 'Required') =>
  value => value ? undefined : message;


export const FaqList = (props) => (
  <List {...props} title="List of FAQs" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="question"/>
      <TextField source="answer"/>
      <NumberField source="order"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const FaqCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/faqs">
      <LongTextInput source="question" validate={required()}/>
      <LongTextInput source="answer" validate={required()}/>
      <NumberInput source="order"/>
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const FaqEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/faqs">
      <FormTab label="Message Info">
        <LongTextInput source="question" validate={required()}/>
        <LongTextInput source="answer" validate={required()}/>
        <NumberInput source="order"/>
      </FormTab>
    </TabbedForm>
  </Edit>
);